import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import GambitManager from './GambitManager';
export default class SearchManager {
  constructor(state) {
    /**
     * An object which stores previously searched queries and provides convenient
     * tools for retrieving and managing search values.
     */
    _defineProperty(this, "state", void 0);
    /**
     * The gambit manager that will convert search query gambits
     * into API filters.
     */
    _defineProperty(this, "gambits", new GambitManager());
    this.state = state;
  }
}
/**
 * The minimum query length before sources are searched.
 */
_defineProperty(SearchManager, "MIN_SEARCH_LEN", 3);
flarum.reg.add('core', 'common/SearchManager', SearchManager);